import get from "lodash/get"
import axios from "axios"
import URITemplate from "urijs/src/URITemplate"
import dayjs from "utils-lib/date"
import { urls } from "utils-lib/builds"
import {
  GET_BULK_PICKUP_DATES_PENDING,
  GET_BULK_PICKUP_DATES_FAILED,
  GET_BULK_PICKUP_DATES_FULFILLED,
} from "constants-lib/actionTypes"

export const pendingAC = () => ({
  type: GET_BULK_PICKUP_DATES_PENDING,
})

export const failedAC = () => ({
  type: GET_BULK_PICKUP_DATES_FAILED,
})

export const fulfilledAC = (data) => ({
  type: GET_BULK_PICKUP_DATES_FULFILLED,
  payload: data,
})

/**
 * Fetches available bulk pickup dates within a specified range and location.
 * @param {string} street - The street address for the pickup location.
 * @param {string} city - The city of the pickup location.
 * @param {string} state - The state of the pickup location.
 * @param {string} country - The country of the pickup location.
 * @param {string} postalCode - The postal code of the pickup location.
 * @param {string} lang - The language preference for the response.
 * @param {string} pickupType - The type of pickup service requested.
 * @param {Function} dispatch - Dispatches actions to the Redux store.
 */
export const getBulkPickupDates =
  (street, city, state, country, postalCode, lang, pickupType) =>
  (dispatch) => {
    dispatch(pendingAC())

    const api = `BULK_PICKUP_DATES`
    const apiKey = get(urls, `apiKey.GUEST[${api}]`, ``)

    const template = URITemplate(urls.url[api])

    const url = template.expand({
      fromDate: dayjs().add(1, `days`).format(`YYYY-MM-DD`),
      toDate: dayjs().add(60, `days`).format(`YYYY-MM-DD`),
      street,
      city,
      state,
      country,
      postalCode,
      pickupType,
      lang,
    })

    const config = {
      headers: {
        apiKey,
      },
    }

    return axios
      .create(config)
      .get(url)
      .then((response) => {
        dispatch(fulfilledAC(response.data))
        return response.data
      })
      .catch(() => {
        dispatch(failedAC())
      })
  }
